var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clearfix" },
    [
      _c(
        "a-upload",
        {
          attrs: {
            action: _vm.action,
            headers: _vm.headers,
            "list-type": "picture-card",
            fileList: _vm.myFileList,
            remove: _vm.removeImg,
          },
          on: { preview: _vm.handlePreview, change: _vm.handleChangeLive },
        },
        [
          _c(
            "div",
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _c("div", { staticClass: "ant-upload-text" }, [_vm._v(" 上传 ")]),
            ],
            1
          ),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: { visible: _vm.previewVisible, footer: null },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { alt: "example", src: _vm.previewImage },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }